import React, { FunctionComponent, useContext } from 'react'
import { TrackingEvent } from '../../../model/amplitude'
import { AchFlowModalContext, AchFlowSteps } from '../AchFlowModalContext'
import { useCreateLinkTokenMutation } from '../../../state'
import { BasePlaid } from '../BasePlaid'

export const CreatePlaid: FunctionComponent = () => {
  const { setStep, setPublicToken } = useContext(AchFlowModalContext)

  const onHandlePlaidFlowFinished = (data): void => {
    setPublicToken(data.token)
    setStep(AchFlowSteps.LinkBankAccount)
  }

  const amplitudeEvents = {
    onError: TrackingEvent.ACH.ViewAddBankAccountError,
    onSuccess: TrackingEvent.ACH.SelectedContinueInPlaidSuccess,
    onOauthError: TrackingEvent.ACH.ViewAddBankAccountOauthError,
    onOauthSuccess: TrackingEvent.ACH.SelectedContinueInPlaidOauthSuccess,
  }

  return <BasePlaid useCreateToken={useCreateLinkTokenMutation} onHandlePlaidFlowFinished={onHandlePlaidFlowFinished} amplitudeEvents={amplitudeEvents} />
}
